import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crown, X } from "lucide-react";

const DAY = 86400000;

export function ExpiryBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const until = user?.premium_until ? new Date(user.premium_until).getTime() : null;
  const msLeft = until ? until - Date.now() : null;
  const [dismissed, setDismissed] = useState(
    () => !!until && sessionStorage.getItem("doek_expiry_dismissed") === String(until)
  );

  if (!until || dismissed) return null;
  const expiringSoon = user?.premium && !user?.auto_renew && msLeft > 0 && msLeft <= 2 * DAY;
  const expired = !user?.premium && msLeft <= 0 && msLeft > -3 * DAY;
  if (!expiringSoon && !expired) return null;

  let label;
  if (expired) {
    label = "Your Premium pass has expired";
  } else if (msLeft < DAY) {
    const hrs = Math.max(1, Math.round(msLeft / 3600000));
    label = `Your Premium pass expires in ${hrs} hour${hrs === 1 ? "" : "s"}`;
  } else {
    const days = Math.round(msLeft / DAY);
    label = `Your Premium pass expires in ${days} day${days === 1 ? "" : "s"}`;
  }

  const dismiss = () => {
    sessionStorage.setItem("doek_expiry_dismissed", String(until));
    setDismissed(true);
  };

  return (
    <div data-testid="expiry-banner" className="bg-amber-500/12 border-b border-amber-500/30">
      <div className="max-w-5xl mx-auto px-5 py-2.5 flex items-center gap-3">
        <Crown className="h-4 w-4 text-amber-400 shrink-0" />
        <p className="flex-1 text-xs sm:text-sm text-amber-100/90 truncate">
          {label}. <span className="text-amber-300/80">Renew to keep your perks.</span>
        </p>
        <button
          data-testid="expiry-renew-btn"
          onClick={() => navigate("/premium")}
          className="btn-gold rounded-full text-xs font-semibold px-4 py-1.5 shrink-0"
        >
          Renew
        </button>
        <button data-testid="expiry-dismiss-btn" onClick={dismiss} className="text-amber-200/60 hover:text-amber-100 shrink-0">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
